import { useRef, useState } from "react";
import { fmtTime } from "@/lib/format";

export const SeekBar = ({ current, duration, buffered, onSeek }) => {
  const ref = useRef(null);
  const [hover, setHover] = useState(null);
  const [drag, setDrag] = useState(null);
  const ratioAt = (clientX) => {
    const r = ref.current.getBoundingClientRect();
    return Math.min(1, Math.max(0, (clientX - r.left) / r.width));
  };
  const shown = drag ?? (duration ? current / duration : 0);
  const onDown = (e) => {
    ref.current.setPointerCapture(e.pointerId);
    setDrag(ratioAt(e.clientX));
  };
  const onMove = (e) => {
    const r = ratioAt(e.clientX);
    setHover(r);
    if (drag !== null) setDrag(r);
  };
  const onUp = (e) => {
    if (drag === null) return;
    onSeek(ratioAt(e.clientX) * duration);
    setDrag(null);
  };
  return (
    <div
      ref={ref}
      data-testid="player-seek-bar"
      onPointerDown={onDown}
      onPointerMove={onMove}
      onPointerUp={onUp}
      onPointerLeave={() => setHover(null)}
      className="group/seek relative h-5 cursor-pointer touch-none flex items-center"
    >
      <div className="relative h-1 group-hover/seek:h-1.5 w-full rounded-full bg-white/20 transition-[height]">
        <div data-testid="player-buffered-bar" className="absolute inset-y-0 left-0 rounded-full bg-white/35" style={{ width: `${duration ? (buffered / duration) * 100 : 0}%` }} />
        <div data-testid="player-played-bar" className="absolute inset-y-0 left-0 rounded-full bg-gradient-to-r from-[#D4AF37] to-[#FFD86A]" style={{ width: `${shown * 100}%` }} />
        <div className="absolute top-1/2 h-4 w-4 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#FFD86A] shadow-[0_0_12px_rgba(255,216,106,0.9)] scale-0 group-hover/seek:scale-100 transition-transform" style={{ left: `${shown * 100}%` }} />
      </div>
      {hover !== null && duration > 0 && (
        <span className="absolute -top-8 -translate-x-1/2 rounded bg-black/85 border border-[#D4AF37]/40 px-2 py-0.5 text-xs text-white" style={{ left: `${hover * 100}%` }}>
          {fmtTime(hover * duration)}
        </span>
      )}
    </div>
  );
};
